import { useEffect } from "react";

import { View, Text } from "../components/base";
import { Spinner } from "../components/base/Spinner";
import { sessionActions } from "../redux/reducers/sessionSlice";
import { useAppDispatch } from "../redux";
import { useNavigate } from "react-router-dom";

type SignOutPageProps = {
  className?: string;
};

export const SignOutPage = ({ className }: SignOutPageProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onMount = async () => {
    await dispatch(sessionActions.signOut()).unwrap();

    navigate("/signin");
  };

  useEffect(() => {
    onMount();
  }, []);

  return (
    <View className={`min-h-screen bg-white dark:bg-gray-900 ${className}`}>
      <View className="w-full max-w-5xl mx-auto p-8 flex flex-col items-center justify-center min-h-screen space-y-6">
        <Spinner className="w-12 h-12 text-brand dark:text-brand-light" />
        <Text
          variant="muted"
          className="text-lg text-center"
        >
          Signing out...
        </Text>
      </View>
    </View>
  );
};
